import Big from 'big.js';

export const priceFormatter = (num: number, minimumFractionDigits = 2, maximumFractionDigits = 2) => {
	return new Intl.NumberFormat('ar-AE', {
		minimumFractionDigits,
		maximumFractionDigits,
	}).format(num);
};

export const toKebabCase = (str: string) =>
	str
		?.match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)
		?.map((x) => x.toLowerCase())
		?.join('-') ?? str;

export const sum = (val1: number, val2: number) => new Big(val1).add(val2).toNumber();

const emirateCountryId = 236;

export const isEmirateCountry = (countryId?: number) => countryId === emirateCountryId;
